import { useContext, useState } from 'react'

import AppContext from '@/context/AppContext'

const useDropOffPoint = () => {
  const { context, setContext } = useContext(AppContext)
  const [showDropOffPointDrawer, setShowDropOffPointDrawer] = useState(false)

  const openDropOffPointDrawer = () => setShowDropOffPointDrawer(true)

  const closeDropOffPointDrawer = () => setShowDropOffPointDrawer(false)

  const selectDropOffPoint = dropOffPoint => {
    setContext(context => ({
      ...context,
      orderInfo: { ...context.orderInfo, selectedServicePoint: dropOffPoint },
    }))
  }

  return {
    showDropOffPointDrawer,
    openDropOffPointDrawer,
    closeDropOffPointDrawer,
    selectDropOffPoint,
    selectedDropOffPoint: context.orderInfo.selectedServicePoint,
  }
}

export default useDropOffPoint
